import React from 'react';

// ThinkingTimer — a count-up "she's working" timer, like Claude's thinking timer.
// Mounts the moment Aria starts thinking, ticks every second (m:ss), and unmounts
// when she replies. Reassures the user it's happening + working, even on the slow
// paths (deep-thinking ~15s, research ~13s). Reuses the existing typing dots; this
// is just the elapsed-time text beside them.
export default function ThinkingTimer({ label = 'Thinking', startTime = null }) {
  const t0 = React.useRef(startTime || Date.now());
  const [secs, setSecs] = React.useState(0);
  React.useEffect(() => {
    t0.current = startTime || Date.now();
    setSecs(0);
    const id = setInterval(() => setSecs(Math.max(0, Math.round((Date.now() - t0.current) / 1000))), 250);
    return () => clearInterval(id);
  }, [startTime]);

  const mm = Math.floor(secs / 60);
  const time = mm > 0 ? `${mm}:${String(secs % 60).padStart(2, '0')}` : `${secs}s`;

  return (
    <span
      className="aria-thinking-timer"
      aria-live="polite"
      style={{ fontSize: 12.5, color: 'var(--text-2,#8a8a92)', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}
    >
      {label ? `${label} · ${time}` : time}
    </span>
  );
}
